import React, { useCallback, useState, useEffect } from 'react';
import { Form, Select, Input, Button, Space, notification, message, Table } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import HrSelect from '@/components/hr-select';
import { examination } from '@/api/examinationApi';
import { useHistory } from "react-router";
import moment from 'moment';
import { removeLeadingAndTrailingSpaces } from "@/utils/index";


const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 6, span: 16 },
};

/** 获取确认 url */
function getConfirmUrl(id: string) {
  return `${location.origin}/confirm_exam/${id}`;
}


/** 制作考生试卷 */
const MakeExamPage: React.FC = props => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState('');
  const [form] = Form.useForm<API.examinationCreate>();
  const [questions, setQuestions] = useState<{value: string; label: string;}[]>([]);
  const [data, setData ] = useState<API.question[]>([]);

  const columns = [
    {
      title: '姓名',
      ellipsis: true,
      dataIndex: ['candidate', 'name'],
      /** 过滤 */
      filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
        return <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button type="primary" onClick={confirm}>搜索</Button>
        </div>;
      },
      onFilter: (value, record) => {
        return record.candidate.name.includes(value);
      }
    },
    {
      title: '邮箱',
      ellipsis: true,
      dataIndex: ['candidate', 'email'],
    },
    {
      title: '手机号',
      ellipsis: true,
      dataIndex: ['candidate', 'phone'],
    },
    {
      title: '试卷',
      dataIndex: ['exam', 'type'],
    },
    {
      title: '创建时间',
      dataIndex: ['exam', 'createdTime'],
      /** 渲染 */
      render(v) {
        return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : '';
      }
    },
    {
      title: 'hr',
      dataIndex: 'hr',
      /** 过滤 */
      filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
        return <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button type="primary" onClick={confirm}>搜索</Button>
        </div>;
      },
      onFilter: (value, record) => {
        return record.hr.map(item => item.hrName).join('').includes(value);
      },
      /** 渲染 */
      render(v: { hrName: string}[]) {
        return v?.map(item => item.hrName).join('、');
      }
    },
    {
      title: '链接',
      dataIndex: ['exam', 'token'],
      /** 渲染 */
      render(v) {
        const url = getConfirmUrl(v);
        return <Space>
          <CopyToClipboard
            text={url}
            onCopy={() => notification.info({ message: '已复制', duration: 2.5 })}
          >
            <Button type="primary">复制链接</Button>
          </CopyToClipboard>
        </Space>;
      }
    },
  ];

  /** 获取未完成试卷的列表 */
  const getUnfinished= () => {
    examination.unfinished().then(res => {
      setData(res.data);
    });
  };

  /** 创建试卷 */
  const getToken = useCallback(async (values: API.examinationCreate) => {
    try {
      setLoading(true);
      const res = await examination.create({
        ...values,
        candidateEmail: removeLeadingAndTrailingSpaces(values.candidateEmail),
        candidatePhone: removeLeadingAndTrailingSpaces(values.candidatePhone),
        candidateName: removeLeadingAndTrailingSpaces(values.candidateName)!
      });
      if(res.code === 0) {
        message.success('已生成考试链接');
        setUrl(`${location.origin}/confirm_exam/${res.data.token}`);
        getUnfinished();
      } else {
        message.success(res.message);
      }
    } catch (e) {
      //
    } finally {
      setLoading(false);
    }
  }, []);

  /** 获取试卷列表 */
  const examinationType = useCallback(async () => {
    try {
      const res = await examination.type();
      if(res.code === 0) {
        setQuestions(res.data.map(item => ({
          value: item.typeId,
          label: item.typeName
        })));
      }
    } finally {
      //
    }
  }, []); 

  useEffect(() => {
    examinationType();
    getUnfinished();
  }, [examinationType]);


  return (
    <div
      id="create_exam"
      style={{ paddingTop: 80, backgroundImage: 'url(assets/img/hero/h1_hero.png)',  backgroundAttachment: 'fixed', minHeight: '100vh'
    }}
    >
      <div style={{ width: 800, margin: '0 auto' }}>
        <div style={{ position: 'relative', marginBottom: '50px' }}>
          <h2 style={{ textAlign: 'center', color: 'white' }}>创建试卷</h2>
          <Button
            style={{ position: 'absolute', top: 0, right: '-150px' }}
            type="primary"
            onClick={() => history.push('/create_exam_lark')}
          >
            创建试卷 With Lark
          </Button>
          <Button
            style={{ position: 'absolute', top: 0, right: '-300px' }}
            type="primary"
            onClick={() => history.push('/result_list')}
          >
            查看考核列表
          </Button>

        </div>
        <Form
          {...layout}
          form={form}
          onFinish={getToken}
          autoComplete="off"
          onFinishFailed={() => {
            setLoading(false);
          }}
        >
          <Form.Item name="examType" label="试卷类型" rules={[{ required: true, message: '试卷类型是必填项' }]}>
            <Select
              placeholder="请选择试卷"
              options={questions}
            />
          </Form.Item>
          <Form.Item
            name="hrIds"
            label="通知HR列表"
            rules={[{ required: true, message: 'hr是必填项' }]}
          >
            <HrSelect
              placeholder="请选择hr"
              mode="multiple"
              allowClear
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
          <Form.Item
            name="candidateName"
            label="考生姓名"
            rules={[{ required: true, message: '姓名是必填项' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="candidatePhone"
            label="考生手机号"
            rules={[{ pattern: /^\d{11}$/, message: '手机号格式有误' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="candidateEmail"
            label="考生邮箱"
            rules={[{ type: 'email', message: '邮箱格式不正确' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                提交
              </Button>
              <Button htmlType="button" onClick={() => form.resetFields()}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </div>

      {url ? (
        <div style={{ textAlign: 'center' }}>
          <Space>
            <span>{url}</span>
            <CopyToClipboard
              text={url}
              onCopy={() => notification.info({ message: '已复制', duration: 2.5 })}
            >
              <Button type="primary">点我复制</Button>
            </CopyToClipboard>
          </Space>
        </div>
      ) : null}
      <h2 style={{ textAlign: 'center', color: 'white' }}>待做题目列表</h2>
      {/* <div style={{color: 'red', margin: '10px 20px'}}>只有选择了 hr 和拥有手机号邮箱的考生才会显示在历史列表里</div> */}
      <div style={{color: 'red', margin: '10px 20px'}}>存在一定延迟</div>
      <Table style={{ margin: '0 20px' }} rowKey={(e: any) => {
        return e.exam.id;
      }} columns={columns} dataSource={data} /> 
    </div>
  );
};

export default MakeExamPage;
